import { render, staticRenderFns } from "./LoginForget.vue?vue&type=template&id=8ff069aa&scoped=true"
import script from "./LoginForget.vue?vue&type=script&lang=js"
export * from "./LoginForget.vue?vue&type=script&lang=js"
import style0 from "./LoginForget.vue?vue&type=style&index=0&id=8ff069aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff069aa",
  null
  
)

export default component.exports